/** Extract {{variable}} names from HTML content */
export function extractVariables(html) {
  const vars = new Set();
  const regex = /\{\{(\w+)\}\}/g;
  let m;
  while ((m = regex.exec(html || '')) !== null) vars.add(m[1]);
  return [...vars].sort();
}

/** Replace {{variable}} placeholders with values */
export function substituteVariables(html, values = {}) {
  return (html || '').replace(/\{\{(\w+)\}\}/g, (match, name) => {
    const val = values[name];
    return val !== undefined && val !== '' ? val : match;
  });
}

/** Convert plain {{var}} tokens to chip spans for Tiptap loading */
export function prepareHtmlForEditor(html) {
  return (html || '').replace(
    /\{\{(\w+)\}\}/g,
    '<span data-type="template-variable" data-name="$1" class="variable-chip">{{$1}}</span>'
  );
}

/** Human-readable label from snake_case variable name */
export function variableLabel(name) {
  return name.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}

export const DEFAULT_VARIABLES = [
  'company_name',
  'effective_date',
  'recipient_name',
  'governing_state',
  'ceo_title',
  'signer_name',
];
